/**
 * Array utils adds little more functionality to native array API
 */

/**
 * Returns values of the first array not found on the second
 * @param {Array} first
 * @param {Array} second
 * @return {Array}
 */
export function difference<T>(first: T[], second: T[]): T[] {
  if (!Array.isArray(first)) {
    return [];
  }
  if (!Array.isArray(second)) {
    return first;
  }

  return first.filter((element) => !second.includes(element));
}
